import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import withLoader from "../../../../components/layouts/WithLoader";
import Calendar from "react-calendar";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import { getEmployees } from "../../../../services/RHService/EmployeeService";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import PayementAvanceSalaireCheque from "../../../banque/PayementsSalaires/PayementAvanceSalaireCheque";
import PayementAvanceSalaireEspece from "../../../banque/PayementsSalaires/PayementAvanceSalaireEspece";
import PayementAvanceSalaireVirement from "../../../banque/PayementsSalaires/PayementAvanceSalaireVirement";
import PayementAvanceSalaireEnLigne from "../../../banque/PayementsSalaires/PayementAvanceSalaireEnLigne";

const AddNewAvance = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const [selectedOption, setSelectedOption] = useState(null);
  const [yearSelected, setYearSelected] = useState(null);
  const [yearSelectedOption, setYearSelectedOption] = useState(null);
  const [allYears, setAllYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [monthPlaceholder, setMonthPlaceholder] = useState("Choisir...");
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [options, setOptions] = useState([]);

  const [employees, setEmployees] = useState();

  const [finalMonth, setFinalMonth] = useState("");

  const [idEmployer, setIdEmployer] = useState();

  const [yearSelectPlaceHolder, setYearSelectPlaceHolder] =
    useState("Choisir...");
  const [methodePayement, setMethodePayement] = useState();

  useEffect(() => {
    setAllYears([]);
    var currentYear = new Date().getFullYear();

    var lastyear = currentYear - 1;
    setAllYears((oldArray) => [
      ...oldArray,
      { value: lastyear, label: lastyear },
    ]);
    setAllYears((oldArray) => [
      ...oldArray,
      { value: currentYear, label: currentYear },
    ]);
    var newyear = currentYear + 1;
    setAllYears((oldArray) => [
      ...oldArray,
      { value: newyear, label: newyear },
    ]);
    setMonthsOptions([]);
    setMonthsOptions([
      { value: "01", label: "Janvier" },
      { value: "02", label: "Février" },
      { value: "03", label: "Mars" },
      { value: "04", label: "Avril" },
      { value: "05", label: "Mai" },
      { value: "06", label: "Juin" },
      { value: "07", label: "Juillet" },
      { value: "08", label: "Aout" },
      { value: "09", label: "Septembre" },
      { value: "10", label: "Octobre" },
      { value: "11", label: "Novembre" },
      { value: "12", label: "Decembre" },
    ]);
    startLoading();
    getEmployees(getCurrentUserId())
      .then((response) => {
        setEmployees(response.data.success);
        const updatedOptions = response.data.success.map((em) => ({
          value: em.id,
          label: em.firstName + " " + em.lastName,
        }));
        setOptions([...updatedOptions]);
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :" + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const onChangeSelectedYear = (selectedOptionn) => {
    setSelectedOption();
    setYearSelected(selectedOptionn.value);
    localStorage.setItem("yearRH",selectedOptionn.value)
    setYearSelectPlaceHolder(selectedOptionn.label);
  };
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    localStorage.setItem("IdEmployeRH",selectedOption.value)
    setIdEmployer(selectedOption.value);
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    localStorage.setItem("monthRH",selectedOption.value)
    setFinalMonth(selectedOption.value);
    console.log(`Option selected:`, selectedOption.value);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setMethodePayement(payement);
  };

  const createUIPayement = () => {
    if (methodePayement === "CHEQUE") {
        return <PayementAvanceSalaireCheque />;
    } else if (methodePayement === "ESPECE") {
        return <PayementAvanceSalaireEspece />
    } else if (methodePayement === "VIREMENT") {
        return <PayementAvanceSalaireVirement />;
    } else if (methodePayement === "ENLIGNE") {
        return <PayementAvanceSalaireEnLigne />;
    }
};
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">Avance</div>
          </div>
        </div>
      </section>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
          <div class="card-header">
          <h3 className="card-title"> Ajouter une avance à un employé </h3>
            </div>

            <div class="card-body">
              <div className="row">
                <div className="form-group col-sm-3">
                  <div>
                    <label>Choisir l'employé</label>
                    <Select
                      value={selectedOption}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={options}
                      onChange={handleChange}
                      defaultValue={selectedOption}
                      placeholder={"Tous"}
                    />
                  </div>
                </div>
                <div class="form-group col-sm-3">
                  <div>
                    <label>Choisir l'année </label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={yearSelectedOption}
                      onChange={onChangeSelectedYear}
                      options={allYears}
                      placeholder={yearSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="form-group col-sm-3">
                  <div>
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      defaultValue={selectedMonth}
                      placeholder={monthPlaceholder}
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <label>Choisir le mode de payement</label>
                  <select class="form-control" onChange={handleChangePayement}>
                    <option key={0} value={0}></option>
                    <option key={1} value={"ESPECE"}>
                      Espèce
                    </option>
                    <option key={2} value={"ENLIGNE"}>
                      En ligne
                    </option>
                    <option key={3} value={"CHEQUE"}>
                      Chèques
                    </option>
                    <option key={4} value={"VIREMENT"}>
                      Virement
                    </option>
                  </select>
                </div>
              </div>
              {createUIPayement()}

            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddNewAvance);
